import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { AuthService, LOGIN_ROUTE } from '../services/auth.service';

/**
 * Gates the authenticated area.
 *
 * Deliberately a CanMatchFn rather than CanActivateFn: canMatch runs BEFORE the
 * lazy chunk is fetched, so a signed-out visitor never downloads the member
 * area's code at all. canActivate would download it first and only then block.
 *
 * This is a UX control, not a security boundary — the visitor owns the browser.
 * Every protected endpoint must still authorise server-side.
 */
export const authGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  // Remember where they were headed so login can send them back.
  const attempted = '/' + segments.map((segment) => segment.path).join('/');

  return router.createUrlTree([LOGIN_ROUTE], {
    queryParams: { returnUrl: attempted },
  });
};
